module.exports = __webpack_public_path__ + "static/media/arrow-red.787f0d35.svg";